import { render } from "./search-suggestions.vue?vue&type=template&id=759749c6"
import script from "./search-suggestions.vue?vue&type=script&lang=js"
export * from "./search-suggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__